import React from 'react';
import { Switch } from 'react-router-dom';
import Loadable from 'react-loadable';

import Login from 'app/modules/login/login';
import Register from 'app/modules/account/register/register';
import RegisterTokenPage from 'app/modules/account/register/registertoken';
import RegisterSimPage from 'app/modules/account/register/registersim';
import RegisterInfo from 'app/modules/account/register/registerInfo';
import Activate from 'app/modules/account/activate/activate';
import SendOtp from 'app/modules/sendOtp/sendOtp';
import PasswordResetInit from 'app/modules/account/password-reset/init/password-reset-init';
import PasswordResetFinish from 'app/modules/account/password-reset/finish/password-reset-finish';
import PasswordResetSendOtp from 'app/modules/account/password-reset/sendOtp';
import PasswordReg from 'app/modules/account/password-reg/password';
import Logout from 'app/modules/login/logout';
import LogOut from 'app/modules/account/user/logout';
import Home from 'app/modules/home/home';
import Entities from 'app/entities';
import PrivateRoute from 'app/shared/auth/private-route';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import PageNotFound from 'app/shared/error/page-not-found';
import UserProfile from 'app/modules/account/user/user-profile';
import { AUTHORITIES } from 'app/config/constants';
import IDPPage from 'app/modules/account/register/idp';
import AdminPage from 'app/shared/layout/menus/adminPage';
import AdminManagerPage from 'app/shared/layout/menus/AdminManager/adminManager';
import RegisterHome from 'app/modules/account/register/registerHome';

import PasswordPage from 'app/modules/account/password-set/password';

// tslint:disable:space-in-parens
const Account = Loadable({
  loader: () => import(/* webpackChunkName: "account" */ 'app/modules/account'),
  loading: () => <div>loading ...</div>
});

const Admin = Loadable({
  loader: () => import(/* webpackChunkName: "administration" */ 'app/modules/administration'),
  //loader: () => import(/* webpackChunkName: "administration" */ 'app/shared/layout/menus/AdminManager'),
  loading: () => <div>loading ...</div>
});
// tslint:enable

const Routes = () => (
  <div className="view-routes" style={{ marginTop: '5px' }}>
    <Switch>
      <PrivateRoute path="/admin" component={Admin} hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.MANAGER]} />
      <ErrorBoundaryRoute path="/logout" component={Logout} />
      <ErrorBoundaryRoute exact path="/register/verify/:username/:key?" component={PasswordPage} />
      <PrivateRoute path="/account" component={Account} hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.USER]} />
      <PrivateRoute path="/entity" component={Entities} hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.USER]} />
      <PrivateRoute path="/" exact component={Home} />
      <ErrorBoundaryRoute component={PageNotFound} />
    </Switch>
  </div>
);

export default Routes;
